import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SuccessZipCode extends DexResourceModel {

    @Field(Number)
    public zipCode: number = 0;
    @Field(String)
    public city: string = "";
    @Field(String)
    public county_uuid: string = "";
    @Field(String)
    public state_uuid: string = "";
    @Field(String)
    public country_uuid: string = "";

    @Field(Boolean)
    public isEFileAvailable: boolean = false;

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
